import styled from "styled-components";

const MainContainer = styled.div`
  background-color: #27496d;
  min-height: 100vh;
`;

export { MainContainer };
